import React from "react";
import Icon1 from "../assets/images/icon-cam-ket-giong-mau.png";
import Icon2 from "../assets/images/icon-ccam-ket-giao-hang-nhanh.png";
import Icon3 from "../assets/images/icon-cam-ket-doi-tra.png";
import Icon4 from "../assets/images/icon-cam-ket-gia-canh-tranh.png";
import Icon5 from "../assets/images/icon-cam-ket-hoa-tuoi.png";
import Icon6 from "../assets/images/icon-cam-ket-uy-tin.png";

const data = [
  {
    image: Icon1,
    title: "Cam Kết Giống Mẫu",
  },
  {
    image: Icon2,
    title: "Cam Kết Giao Nhanh Chóng",
  },
  {
    image: Icon3,
    title: "Cam Kết Đổi Trả Miễn Phí",
  },
  // {
  //     image: Icon4,
  //     title: "Cam Kết Giá Cạnh Tranh"
  // },
  {
    image: Icon5,
    title: "Cam Kết 100% Hoa Tươi",
  },
  {
    image: Icon6,
    title: "Cam Kết Đảm Bảo Uy Tín",
  },
];

const Commit = () => {
  return (
    <div className="commit-container">
      <div className="commit-title">
        <div className="title-text">
          <i className="bi bi-star-fill pe-2"></i>Thanh Flower Thực Hiện 5 Cam
          Kết
        </div>
      </div>
      <div className="commit-content">
        {data.map((item, idx) => (
          <div className="commit-content-item" key={idx}>
            <div className="img-item">
              <img src={item.image} alt="" />
            </div>
            <p>{item.title}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Commit;
